import { Injectable } from '@angular/core';
import { treatmentTypeMap } from '@data/treatment-types/treatment-type-map';
import { ConsultationTreatmentTypes } from '@enums/consultation-treatment-types';
import { environment } from '@environments/environment';
import { TreatmentType } from '@models/treatment-types/treatment-type.model';

/**
 * Service responsible for providing access to instantiated TreatmentFormSetting objects.
 * It loads the raw settings data specific to the current site context and creates
 * class instances based on the requested treatment type.
 */
@Injectable({ providedIn: 'root' })
export class TreatmentTypeService {
  /**
   * Gets an instantiated TreatmentType object for a specific treatment type.
   * The object contains both the settings data and associated methods (e.g., isGenderDisallowed).
   *
   * @param treatmentType The type of treatment.
   * @returns An instance of `TreatmentType` initialized with the relevant data,
   *          or `null` if no settings data is found for the given type.
   */
  public getTreatmentType(treatmentType: ConsultationTreatmentTypes): TreatmentType | null {
    const treatmentInfo = treatmentTypeMap.get(treatmentType);

    if (!treatmentInfo) {
      return null;
    }

    return treatmentInfo.siteData?.get(environment.site) || treatmentInfo.default;
  }
}
